<markant-platform-ui-card
  class="management-tile calculation-params-tile"
  [headline]="'cartridge.management.calculationParameters.headline' | transloco"
>
  <ul class="list-params">
    <li *ngFor="let calcParam of calculationParametersData">{{ calcParam }}</li>
  </ul>
</markant-platform-ui-card>
